import EditIcon from "components/Icons/EditIcon";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import DeleteIcon from "components/Icons/DeleteIcon";
import { useCityAlertContext } from "./CityAlertContext";
import { ICity } from "models/city";

interface IProps {
  city: ICity;
}

export default function Action({ city }: IProps) {
  const { showDelete } = useCityAlertContext();

  const handleDelete = () => showDelete(city);

  return (
    <div className="flex items-center gap-x-3">
      <Link
        to={RouteName.EDIT_CITY.replace(":id", city.id)}
        className="rounded-ful hover:text-black"
      >
        <EditIcon />
      </Link>
      <button onClick={handleDelete} className="rounded-ful">
        <DeleteIcon />
      </button>
    </div>
  );
}
